/**
 * @generated SignedSource<<8aaeb8fcb00d28fb96a33e0e9ced5f7b>>
 * @relayHash 0f0cf055d22a7fe18588fe6d67036bf4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 34d7440f1d6578d9e73c149771b7333cec75ce1895497092438dc38632319ec2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { GlobalBrandingQuery } from './GlobalBrandingQuery.graphql';

const node: PreloadableConcreteRequest<GlobalBrandingQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "34d7440f1d6578d9e73c149771b7333cec75ce1895497092438dc38632319ec2",
    "metadata": {},
    "name": "GlobalBrandingQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
